export const DOWNLOAD_ACH_REQUEST = "DOWNLOAD_ACH_REQUEST"
export const DOWNLOAD_ACH_SUCCESS = "DOWNLOAD_ACH_SUCCESS"
export const GET_ACH_LIST_REQUEST = "GET_ACH_LIST_REQUEST"
export const GET_ACH_LIST_SUCCESS = "GET_ACH_LIST_SUCCESS"
export const CHANGE_STATUS_ACH_REQUEST = "CHANGE_STATUS_ACH_REQUEST"
export const CHANGE_STATUS_ACH_SUCCESS = "CHANGE_STATUS_ACH_SUCCESS"
export const ACH_REQUEST = "ACH_REQUEST"
export const ACH_SUCCESS = "ACH_SUCCESS"

export const ACH_LOGS_REQUEST = "ACH_LOGS_REQUEST"  
export const ACH_LOGS_SUCCESS = "ACH_LOGS_SUCCESS"